import { AppSettings } from "../../managers/AppSettings";
import { LoaderFileKeys } from "../../constant/AppConstants";
import { DealsListItem } from "./DealsListItem";
import { DealsHeaderItem } from "./DealsHeaderItem";
import { SideScoreItem } from "./SideScoreItem";
import { SettingsItem } from "../options/SettingsItem";
import { DealsListItemData, TextureData } from "../../../types/types";
import { ScrollPaneTitledListContent } from "./ScrollPaneTitledListContent";
import { AppLocalization } from "../../localization/AppLocalization";
import { ThemeDataManager } from "../../managers/ThemeDataManager";
import { AppObjectPool } from "../../pooling/AppObjectPool";
import { LayoutDataManager } from "../../managers/LayoutDataManager";
import { AppFontsConfig } from "../../data/AppConstants";
import { ResultsListItemBubbleColor } from "./ResultsListItem";


export type DealCompleteDealsContentData = {
    items: DealsListItemData[];
    scoreUs: number;
    scoreThem: number;
    totalScoreBubbleColorUs: ResultsListItemBubbleColor;
    totalScoreBubbleColorThem: ResultsListItemBubbleColor;
}

export enum ContractResult {

    /**
     * Party that DECLARED/MADE the contract (EDIT: what if i counter?) was able to succesfully FULFILL the contract.
     */
    CONTRACT_SUCCESS = 0,
    /**
     * Party that made the contract was unable to FULFILL the contract and the opposing party WON the deal instead.
     */
    CONTRACT_FAILURE = 1,
    CONTRACT_TIE = 2,
}

/**
 *  
 * @param value Returns localized contract label eg 'Done' or 'Failed' 
 *              based on ContractResult
 * @returns 
 */
export function ContractResultToContractLabel(value: ContractResult): string {
    switch (value) {
        case ContractResult.CONTRACT_SUCCESS:
            return AppLocalization.GetVariationData().dealComplete.deals.deal.result.success;
        case ContractResult.CONTRACT_FAILURE:
            return AppLocalization.GetVariationData().dealComplete.deals.deal.result.failure;
        case ContractResult.CONTRACT_TIE:
            return AppLocalization.GetVariationData().dealComplete.deals.deal.result.tie;
    }
}

export function ContractResultToBubbleFrame(value: ContractResult): string {
    switch (value) {
        case ContractResult.CONTRACT_SUCCESS:
            return ThemeDataManager.GetVariationData().dealComplete.deals.contractResultFrame.success;
        case ContractResult.CONTRACT_FAILURE:
            return ThemeDataManager.GetVariationData().dealComplete.deals.contractResultFrame.failure;
        case ContractResult.CONTRACT_TIE:
            return ThemeDataManager.GetVariationData().dealComplete.deals.contractResultFrame.tie;
    }
}

export class DealCompleteDealsContent
    extends ScrollPaneTitledListContent {
    public imgSideScoreItemsBg: Phaser.GameObjects.Image;
    public scoreUs: SideScoreItem;
    public scoreThem: SideScoreItem;

    private sideScoreItemsBgHeight: number = 250;

    /**
     * Game object pool for DealsListItem-s
     * - we reuse these complex objects, since there is variable amount of them in this component
     * - this pool only contains those, that are NOT visible
     */
    protected poolGroupKey: string = "DealsListItem";

    private itemBgTextureData: TextureData;
    private itemLabelTextStyle: Phaser.Types.GameObjects.Text.TextStyle;

    private delimiterLineAlpha: number;


    public override Init(): void {
        // > items
        super.Init();

        this.delimiterLineAlpha = LayoutDataManager.GetSharedData().general.screen.item.delimiterLine.alpha;

        this.nodeLoc = AppLocalization.GetVariationData().dealComplete.deals;
        this.nodeTheme = ThemeDataManager.GetVariationData().dealComplete.deals;
    }

    public override Build(): void {
        // > build title
        super.Build();
        this.add(this.nsContentBg);

        // refs
        const headerStyle = {
            color: AppSettings.colors.yellowString,
            align: "left",
            // fontSize: "36px",
            // fontFamily: AppSettings.fontFamilies.MontserratBold,
            // metrics: AppSettings.metrics.montserratBold36,
            fontFamily: AppFontsConfig.DealCompleteHeaderItemLabel.fontFamily,
            fontSize: AppFontsConfig.DealCompleteHeaderItemLabel.fontSize,
            metrics: AppFontsConfig.DealCompleteHeaderItemLabel.metrics,
        };
        this.itemLabelTextStyle = {
            color: AppSettings.colors.whiteString,
            align: "left",
            // fontSize: "36px",
            // fontFamily: AppSettings.fontFamilies.MontserratBold,
            // metrics: AppSettings.metrics.montserratBold36,
            fontFamily: AppFontsConfig.DealCompleteListItemLabel.fontFamily,
            fontSize: AppFontsConfig.DealCompleteListItemLabel.fontSize,
            metrics: AppFontsConfig.DealCompleteListItemLabel.metrics,

        };
        // const headerTextureData = {texture:LoaderFileKeys.ui, frame:"rect-2x2-black.png"};
        const headerTextureData = { texture: LoaderFileKeys.ui, frame: "rect-2x2-transparent.png" };
        this.itemBgTextureData = { texture: LoaderFileKeys.ui, frame: "rect-2x2-transparent.png" };

        // header
        // - top most table row
        const header: DealsHeaderItem = new DealsHeaderItem(this.scene);
        header.Init(
            headerTextureData,
            headerStyle,
            LayoutDataManager.GetSharedData().general.screen.header.delimiterLine.alpha,
        );
        header.Build();
        header.SetData(
            this.nodeLoc.cats[0].itemLabel,
            this.nodeLoc.cats[1].itemLabel,
            this.nodeLoc.cats[2].itemLabel,
            this.nodeLoc.cats[3].itemLabel,
            this.nodeLoc.cats[4].itemLabel,
        );
        this.add(header);
        this.header = header;

        this.imgSideScoreItemsBg = this.scene.make.image({ key: LoaderFileKeys.ui, frame: "rect-2x2-transparent.png" });
        this.imgSideScoreItemsBg.setOrigin(0);
        this.add(this.imgSideScoreItemsBg);

        this.scoreUs = new SideScoreItem(this.scene);
        this.scoreUs.Init();
        this.scoreUs.Build();
        this.add(this.scoreUs);

        this.scoreThem = new SideScoreItem(this.scene);
        this.scoreThem.Init();
        this.scoreThem.Build();
        this.add(this.scoreThem);

        // this.UpdateFromLocalizationChange();
    }

    /**
     * Localized language changed. Update text.
     */
    public UpdateFromLocalizationChange(): void {
        this.nodeLoc = AppLocalization.GetVariationData().dealComplete.deals;
        const sTitle: string = this.nodeLoc.title.itemLabel;

        this.btnTitle.SetLabel(sTitle);
        this.scoreUs.SetTitle(this.nodeLoc.us.itemLabel);
        this.scoreThem.SetTitle(this.nodeLoc.them.itemLabel);
        (this.header as DealsHeaderItem).SetData(
            this.nodeLoc.cats[0].itemLabel,
            this.nodeLoc.cats[1].itemLabel,
            this.nodeLoc.cats[2].itemLabel,
            this.nodeLoc.cats[3].itemLabel,
            this.nodeLoc.cats[4].itemLabel,
        );
    }

    public SetData(inputData: DealCompleteDealsContentData): void {
        // console.log("DealCompleteDealsContent::SetData");
        // console.log("this.items.length=",this.items.length,"inputData.items.length=",inputData.items.length);

        // match number of items required by input data model 
        // with number of items on screen/in live data model
        // got more items on screen than i need to display (new data model)
        if (this.items.length > inputData.items.length) {
            // pool excess items from screen to pool
            let numPoolItems = this.items.length - inputData.items.length;
            while (numPoolItems--) {
                const item: SettingsItem = this.items.pop();
                // remove item from live data model/view
                this.remove(item);
                AppObjectPool.DropObject(item, this.poolGroupKey);
            }
        }
        else
            // if got not enough items on screen (need to display more (new data))
            if (this.items.length < inputData.items.length) {
                // create (or take from pool) additional items to put on screen
                let numCreateItems = inputData.items.length - this.items.length;
                let item: DealsListItem;
                while (numCreateItems--) {
                    // got item in pool
                    if (AppObjectPool.GetObjectsCount(this.poolGroupKey) > 0) {
                        item = AppObjectPool.PickObject(this.poolGroupKey);
                    }
                    // no more items in pool
                    else {
                        // create new, initialize, build
                        item = new DealsListItem(this.scene);
                        item.Init(
                            this.itemBgTextureData,
                            this.itemLabelTextStyle,
                            this.delimiterLineAlpha,
                        );
                        item.Build();
                    }
                    // move item to live data model/view
                    this.items.push(item as any);
                    this.add(item);
                }
            }

        // now set data models of onscreen items
        this.items.forEach((item: any, i: number) => {
            (item as DealsListItem).SetData(
                inputData.items[i],
                // this.items.length != i+1,
                true // show delimiter on last item as well, since then we get global score US/THEM and its nice to separate items from it
            );
        });

        let scoreUsValueBgColor: number;
        let scoreThemValueBgColor: number;
        switch(inputData.totalScoreBubbleColorUs) {
            case ResultsListItemBubbleColor.GREEN:
                scoreUsValueBgColor = AppSettings.colors.green;
                break;
            case ResultsListItemBubbleColor.RED:
                scoreUsValueBgColor = AppSettings.colors.red;
                break;
            case ResultsListItemBubbleColor.ORANGE:
                scoreUsValueBgColor = AppSettings.colors.orange;
                break;
        }
        switch(inputData.totalScoreBubbleColorThem) {
            case ResultsListItemBubbleColor.GREEN:
                scoreThemValueBgColor = AppSettings.colors.green;
                break;
            case ResultsListItemBubbleColor.RED:
                scoreThemValueBgColor = AppSettings.colors.red;
                break;
            case ResultsListItemBubbleColor.ORANGE:
                scoreThemValueBgColor = AppSettings.colors.orange;
                break;
        }
        this.scoreUs.SetData(inputData.scoreUs, scoreUsValueBgColor); // value, valueBgColor
        this.scoreThem.SetData(inputData.scoreThem, scoreThemValueBgColor); // value, valueBgColor

        this.sendToBack(this.nsContentBg);
    }

    /**
     * Custom override to SetWidth
     * 
     * @alike: OnResize
     * 
     * Set width->Get Size (width, height)
     * - Set width, calc height for each item separately 
     *   and height for whole content in totality
     * - repositions and rescales items
     * - specific for @see DealCompleteDealsContent: Add [US] and [THEM] SideScoreItem views
     * 
     * @param width  
     */
    public override SetWidth(width: number): void {
        // console.log("DealCompleteDealsContent::SetWidth");

        // position and calculate size for all base items
        super.SetWidth(width);

        // stretch bg for SideScoreItem-s
        this.imgSideScoreItemsBg.y = this.size.height;
        this.imgSideScoreItemsBg.setDisplaySize(width, this.sideScoreItemsBgHeight);

        // SideScoreItem-s
        // position 
        const sideScoreItemsY: number = this.size.height + this.sideScoreItemsBgHeight * 0.5;
        this.scoreUs.setPosition(width * 0.27, sideScoreItemsY);
        this.scoreThem.setPosition(width * 0.73, sideScoreItemsY);

        // increase this.size appropriately
        this.size.height += this.sideScoreItemsBgHeight;

        this.RedrawBorder();
    }
}